import { useQuery } from '@tanstack/react-query';

import type { AccountConfig } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { extranetQueryKeys } from '../queryKeys';

export const useAccountConfig = (enabled = true) =>
  useQuery({
    queryKey: extranetQueryKeys.account.config(),
    queryFn: () => getExtranetApi().get<Record<string, never>, AccountConfig>('/v1/extranet/account/config', {}),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
